import { initializeApollo } from "utils/with-apollo.utils";

import {
  LegacyCatalogDocument,
  LegacyCatalogQuery,
} from "./legacy-catalog.query.generated";

export const getLegacyEntries = async () => {
  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query<LegacyCatalogQuery>({
    query: LegacyCatalogDocument,
  });

  return data?.legacyCatalog?.data?.attributes?.entries?.map((entry) => {
    const flagshipVariant =
      entry?.flagship?.data?.attributes?.smartphoneVariant?.data?.attributes;
    const flagshipPicture = flagshipVariant?.combinedPicture?.data?.attributes;
    const flagshipPictureText = flagshipPicture?.alternativeText;
    const flagshipPictureFormats = flagshipPicture?.formats;

    const picture = {
      alternativeText: flagshipPictureText ?? null,
      medium: flagshipPictureFormats?.medium?.url ?? null,
      thumbnail: flagshipPictureFormats?.thumbnail?.url ?? null,
    };

    const brand = flagshipVariant?.smartphoneFamily?.data?.attributes?.brand;

    const slug = `/${flagshipVariant?.smartphoneFamily?.data?.attributes?.slug}`;

    return {
      entryName: entry?.entryName ?? "",
      brand: brand ?? "",
      picture,
      slug,
    };
  });
};
